module.exports = __webpack_public_path__ + "img/hy_get.0d0b8d3.png";